import { graphql } from '@eluve/graphql.tada';

export const markAppointmentAsCompleteMutation = graphql(`
  mutation markAppointmentAsComplete(
    $id: uuid!
    $userCompletedAt: timestamptz!
  ) {
    updateAppointments(
      where: { id: { _eq: $id } }
      _set: { status: COMPLETED, userCompletedAt: $userCompletedAt }
    ) {
      returning {
        __typename
        id
        status
        userCompletedAt
        completedAt
      }
    }
  }
`);

export const updateSegmentEndedAtMutation = graphql(`
  mutation updateSegmentEndedAt(
    $tenantId: uuid!
    $appointmentId: uuid!
    $segmentId: uuid!
    $recordingEndedAt: timestamptz!
  ) {
    updateAppointmentSegmentsByPk(
      pkColumns: {
        tenantId: $tenantId
        appointmentId: $appointmentId
        id: $segmentId
      }
      _set: { recordingEndedAt: $recordingEndedAt }
    ) {
      id
      recordingEndedAt
    }
  }
`);

export const setAppointmentStartedAtMutation = graphql(`
  mutation setAppointmentStartedAt($id: uuid!, $tenantId: uuid!) {
    updateAppointments(
      where: {
        id: { _eq: $id }
        tenantId: { _eq: $tenantId }
        status: { _eq: NOT_STARTED }
      }
      _set: { startedAt: NOW, status: ACTIVE }
    ) {
      returning {
        id
        startedAt
        status
      }
    }
  }
`);
